// eslint-disable-next-line import/prefer-default-export
export function formatDate(value, format) {
    if (!value) {
        return '';
    }
    if (Array.isArray(format)) {
        format = format[0];
    }
    return value.format(format);
}
